import axios from "axios";
import { getAccessTokenCookie, getViewerAccessToken } from "./authToken";
import { getWebRuntimeAccessToken } from "./runtimeSession";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_EXPERIENCE_URL,
  responseType: "json",
});

api.interceptors.request.use((config) => {
  const authMode = config.authMode || "teacher";
  let token = null;

  if (authMode === "teacher") {
    token = getAccessTokenCookie();
  } else if (authMode === "viewer") {
    token = getViewerAccessToken();
  } else if (authMode === "runtime") {
    token = getWebRuntimeAccessToken();
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
